import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import './LikeIcon.css';
import { Get_Feedback } from '../../../api';

export interface LikePopupProps {
  onClose: () => void;
  message_id?: string;
}

export const LikePopup: React.FC<LikePopupProps> = ({ onClose, message_id }) => {
  const [selectedReasons, setSelectedReasons] = useState<string[]>([]);
  const [additionalFeedback, setAdditionalFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [feedbackStatus, setFeedbackStatus] = useState<"success" | "error" | null>(null);
  const [validationError, setValidationError] = useState<string | null>(null);

  useEffect(() => {
    if (feedbackStatus) {
      const timer = setTimeout(() => {
        onClose();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [feedbackStatus, onClose]);

  const handleReasonSelect = (reason: string) => {
    const isSelected = selectedReasons.includes(reason);
    if (isSelected) {
      setSelectedReasons(selectedReasons.filter((r) => r !== reason));
    } else {
      setSelectedReasons([...selectedReasons, reason]);
    }
  };

  const handleSubmit = async () => {
 //   console.log('LIKE_ID:', message_id);
      if (selectedReasons.length === 0 && !additionalFeedback.trim()) {
    setValidationError("Please select at least one reason or provide additional feedback.");

    //    setTimeout(() => {
    //   setValidationError(null);
    // }, 3000); 
    return;
  }

  setValidationError(null); 
    setLoading(true);

    const FeedBack_Response = await Get_Feedback(message_id, selectedReasons, additionalFeedback);
   // console.log("Feedback response status:", FeedBack_Response.status);

    if (FeedBack_Response.status === 200) {
      setFeedbackStatus("success");
    } else {
      setFeedbackStatus("error");
    }

    setLoading(false);
    setAdditionalFeedback("");
    setSelectedReasons([]);
  };

  return (
    <Modal
      open={true}
      onClose={onClose}
      aria-labelledby="feedback-modal-title"
      aria-describedby="feedback-modal-description"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className="modal-content">
        <div className="d-flex align-items-center justify-content-between">       
        <h3 id="feedback-modal-title" className="modal-title mt-0 mb-2">Why did you choose this rating? (optional)</h3>
        <button onClick={onClose} className="close-btn">X</button>
        </div>
        <div className="button-group">
          <button
            className={`feedback-btn ${selectedReasons.includes('correct') ? 'selected' : ''}`}
            onClick={() => handleReasonSelect('correct')}>
            Correct
          </button>
          <button
            className={`feedback-btn ${selectedReasons.includes('Easy-To-Understand') ? 'selected' : ''}`}
            onClick={() => handleReasonSelect('Easy-To-Understand')}>
            Easy To Understand
          </button>
          <button
            className={`feedback-btn ${selectedReasons.includes('Complete') ? 'selected' : ''}`}
            onClick={() => handleReasonSelect('Complete')}>
            Complete
          </button>
        </div>
        <textarea
          placeholder="Provide Additional Feedback (Optional)"
          value={additionalFeedback}
          onChange={(e) => setAdditionalFeedback(e.target.value)}
          className="feedback-textarea"
          maxLength={300}
        />
{validationError && (
  <div className="validation-error">{validationError}</div>
)}
        <div style={{ marginTop: "10px" }}>
          {loading ? (
            <div className="loading-spinner-Like"></div>
          ) : feedbackStatus === "success" ? (
            <div className="success-message">
              Feedback submitted successfully! 
            </div>
          ) : feedbackStatus === "error" ? (
            <div className="error-message">
             Failed to submit feedback! 
            </div>
          ) : (
            <button className="submit-btn" onClick={handleSubmit}>
              Submit
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};